<template>
  <div
    v-if="video.type === 'YouTube'"
    :style="maxWidth"
    class="video"
    :class="styleClasses"
  >
    <div class="relative aspect-video">
      <iframe
        title="youtube video"
        :src="'https://www.youtube.com/embed/' + video.id"
        class="aspect-video w-full"
        style="aspect-ratio: 16/9;"
      ></iframe>
    </div>
  </div>
  <div
    v-else-if="video.type === 'Asset'"
    :style="maxWidth + width"
    class="video"
    :class="styleClasses"
  >
    <video playsinline autoplay muted preload="auto" loop :data-not-lazy="lazy">
      <source :src="video.video.fields.file.url" />
      <track kind="captions" />
    </video>
  </div>
  <div
    v-else-if="
      video.type === 'Mobile Device' || video.type === 'Desktop Device'
    "
    :class="deviceClasses + styleClasses"
  >
    <video playsinline autoplay muted preload="auto" loop :data-not-lazy="lazy">
      <source :src="video.video.fields.file.url" />
      <track kind="captions" />
    </video>
  </div>
  <div
    v-else-if="video.type === 'Vimeo'"
    :style="maxWidth"
    class="video"
    ref="vimeo"
  >
    <div class="relative video--frameless">
      <iframe
        class="block absolute h-full w-full"
        id="vimeo-video"
        :src="
          `https://player.vimeo.com/video/${video.id}?autoplay=1&loop=1&muted=1&portrait=0&controls=${videoControls}&title=0`
        "
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.video--frameless {
  padding-bottom: 44.6%;
  box-shadow: 1px 0 41px 2px rgba(0, 38, 62, 0.06);
}
</style>
<script>
export default {
  props: {
    video: {
      type: Object,
      required: true
    },
    lazy: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      videoControls: "0"
    };
  },
  computed: {
    deviceClasses() {
      const deviceClasses =
        this.video.type === "Mobile Device"
          ? "device--mobile"
          : this.video.type === "Desktop Device"
          ? "device--laptop"
          : "";
      return `device ${deviceClasses}`;
    },
    maxWidth() {
      return this.video.maxWidth ? `max-width:${this.video.maxWidth}px;` : "";
    },
    width() {
      return this.video.width ? `width:${this.video.width}px;'` : "";
    },
    styleClasses() {
      const classes = {
        "Right Aligned": " float-right"
      };
      return this.video.style ? classes[this.video.style] : "";
    }
  },
  mounted() {
    const isVimeo = this.$refs.vimeo ? this.$refs.vimeo : null;
    if (isVimeo) {
      const matchMedia = window.matchMedia(" (max-width: 736px) ");
      const video = document.querySelector("#vimeo-video");
      const videoSrc = video ? video.getAttribute("data-id") : "";

      let vm = this;

      function swapVideo(matchMedia) {
        vm.videoControls = matchMedia.matches ? "1" : "0";
      }

      swapVideo(matchMedia);
      matchMedia.addListener(swapVideo);
    }
  }
};
</script>
